<template>
  <a class="result" :href="villa.url" @click.prevent="navigateToPath(villa.url)">
    <div class="result-thumbnail lazyload" :style="{ backgroundImage: `url(${getHost}${getThumbnail})` }" />
    <div class="result-right text-dark">
      <div class="result-meta">
        <div class="result-region">
          <p>{{ villa.loc }}, {{ villa.region }}</p>
        </div>
        <div class="result-name" translate="no">
          {{ villa.name }}
        </div>
      </div>
      <div class="result-remove" title="Remove villa" @click="removeItem($event)">
        <Cross :width="14" :height="14" />
      </div>
      <div class="result-occupancy uppercase">
        <p>
          {{ villa.sleeps }} Guests
        </p>
        <p>
          {{ villa.beds }} Beds
        </p>
        <p>
          {{ villa.baths }} Bathrooms
        </p>
      </div>
    </div>
  </a>
</template>

<script>

import routerLink from '../../../mixins/routerLink';
import Cross from '../../icons/Cross.vue';

export default {
  components: {
    Cross,
  },
  mixins: [routerLink],
  props: {
    villa: {
      type: Object,
      required: true,
    },
    thumbnail: {
      type: String,
      default: 'placeholder.png', // link to public/thumb.jpg
    },
  },
  computed: {
    getThumbnail() {
      return this.thumbnail;
    },
    getUrl() {
      return this.villa.url;
    },
    getHost() {
      return 'https://www.thethinkingtraveller.com';
    },
  },
  methods: {
    removeItem(ev) {
      if (this.villa && ev) {
        ev.preventDefault();
        ev.stopPropagation();
        this.$store.dispatch('common/removeShortlist', this.villa);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/styles/settings/config.scss";

.result {
  position: relative;
  display: flex;
  flex-flow: row nowrap;
  width: 100% !important;
  max-width: 100% !important;
  height: 84px !important;
  min-height: 84px !important;
  margin: 0 !important;
  background-color: $stoneWhite;
  transition: background-color $transition-duration $transition-easing;
  min-height: 84px;
  overflow: hidden;
  border-radius: 0;
  &:first-child {
    border-top: 0;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    .result-thumbnail {
      border-top-left-radius: 4px;
    }
  }
  &:hover {
    background-color: $offwhite;
    text-decoration: none;
  }
  &-right {
    display: flex;
    flex-flow: row wrap;
    width: 100%;
    background-color: $stoneCream;
    border: 1px solid $stoneLight;
    padding: 5px;
    p {
      margin: 0;
    }
  }
  &-thumbnail {
    display: flex;
    width: 84px;
    min-width: 84px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    z-index: 0;
  }
  &-meta {
    display: flex;
    flex-flow: column wrap;
    flex: 1;
    align-self: center;
  }
  &-region {
    font-size: 10px;
    text-transform: uppercase;
  }
  &-name {
    font-size: 14px;
    line-height: 1;
  }

  &-occupancy {
    display: flex;
    flex-flow: row nowrap;
    align-self: center;
    width: 100%;
    font-size: 10px;

    p {
      // display: flex;
      // width: 2.75rem; // normalize width
      // text-align: center;
      line-height: 1;

      &:not(:last-child) {
        margin-right: 0.4rem;
      }
    }
  }
  &-remove {
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
    padding: 8px 8px 0px 0;
  }
}

@media (min-width: 768px) {

  .result-remove {
      padding: 0.85rem 0.85rem 0.85rem 0;

      svg {
        width: 12px;
        height: 12px;
      }
  }
}

</style>
